import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { ApiResponse, IApiQueryOptions } from 'api/ApiClient';
import { ApiQueryOperator, IAction, IApiList, IEmployeePayrollTip, IPayPeriod, IPayPeriods, PayoutStatus } from 'types';
import { formatDateForApi } from 'utils';
import * as API from '../../../api';
import * as Actions from './actions';
import * as ActionTypes from './types';

interface IEmployeePayrollTipsPayload {
  siteId: string;
  startDate: string;
  endDate: string;
  options?: IApiQueryOptions;
}

export function* getEmployeePayrollTips({ payload }: IAction<ActionTypes.EmployeePayrollTips, IEmployeePayrollTipsPayload>) {
  try {
    const response: ApiResponse<IApiList<IEmployeePayrollTip>> = yield call(API.Sites.getEmployeePayrollTips, payload.siteId, payload.startDate, payload.endDate, payload.options);
    yield put(Actions.getEmployeePayrollTipsSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getEmployeePayrollTipsError(error));
  }
}
export function* getPayPeriodPayrollTips({ payload }: IAction<ActionTypes.EmployeePayrollTips, { siteId: string; date: string; payPeriod?: IPayPeriod; onSuccess?: (res: IPayPeriod) => void }>) {
  try {
    const { siteId, date, onSuccess } = payload;
    let { payPeriod } = payload;

    // Looked up by date only when the caller could not load it.
    if (!payPeriod) {
      const payPeriodsResponse: ApiResponse<IPayPeriods> = yield call(API.Sites.getPayPeriod, siteId, { date: formatDateForApi(date) });
      [payPeriod] = payPeriodsResponse.body.data;
    }
    if (!payPeriod) throw new Error('No pay period found for the provided date.');

    const options: IApiQueryOptions = { q: [{ key: 'status', operator: ApiQueryOperator.eq, value: PayoutStatus.PAYROLL }], limit: 0 };
    const payrollTipsResponse: ApiResponse<IApiList<IEmployeePayrollTip>> = yield call(API.Sites.getEmployeePayrollTips, siteId, payPeriod.start, payPeriod.end, options);

    if (onSuccess) yield call(onSuccess, payPeriod);

    yield put(Actions.getPayPeriodPayrollTipsSuccess(payrollTipsResponse.body));
  } catch (error: any) {
    yield put(Actions.getPayPeriodPayrollTipsError(error));
  }
}

export function* watchGetEmployeePayrollTips() {
  yield takeLatest(ActionTypes.EmployeePayrollTips.GET_EMPLOYEE_PAYROLL_TIPS_REQUEST, getEmployeePayrollTips);
}

export function* watchGetPayPeriodPayrollTips() {
  yield takeLatest(ActionTypes.EmployeePayrollTips.GET_PAY_PERIOD_PAYROLL_TIPS_REQUEST, getPayPeriodPayrollTips);
}

function* employeePayrollTipsSaga() {
  yield all([fork(watchGetEmployeePayrollTips), fork(watchGetPayPeriodPayrollTips)]);
}
export { employeePayrollTipsSaga };
